<!-- 海口应收账列表打印模板 -->
<template>
    <div v-loading="loading">
        <div id="printListContent">
            <div style="width:210mm;margin: 0 auto;color: #000;">
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ titleConfig.RValue }}</div>
                    </div>
                </div>

                <div style="width:203mm;margin: 0 auto;" id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333">
                        <thead>
                            <tr style="text-align:center;font-weight: bold;">
                                <td width="5%">
                                    <div><b>序号</b></div>
                                </td>
                                <td width="40%">
                                    <div><b>客户名称</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>客户类型</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>欠款总额</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>代收总额</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>预收款余额</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in dataList">
                                <td style="text-align:center;">{{ Number(index) + 1 }}</td>
                                <td>{{ AP.EntpCusName }}</td>
                                <td>{{ AP.Tags }}</td>
                                <td style="text-align: right;">{{ AP.RSumPayable }}&nbsp;</td>
                                <td style="text-align: right;">{{ AP.AgentSum }}&nbsp;</td>
                                <td style="text-align: right;">{{ AP.AdvanceMoney }}&nbsp;</td>
                            </tr>
                            <tr style="text-align:center;font-weight: bold;">
                                <td colspan="3">
                                    <div><b>合计</b></div>
                                </td>
                                <td width="15%" align="right">{{ rSumPayableTotal.toFixed(2) }}&nbsp;</td>
                                <td width="15%" align="right">{{ agentSumTotal.toFixed(2) }}&nbsp;</td>
                                <td width="15%" align="right">{{ advanceMoneyTotal.toFixed(2) }}&nbsp;</td>
                            </tr>
                        </tbody>
                        <!-- <tfoot>
                            <tr style="text-align:center;font-weight: bold;">
                                <td colspan="3">
                                    <div><b>合计</b></div>
                                </td>
                                <td width="15%" align="right">{{ rSumPayableTotal.toFixed(2) }}&nbsp;</td>
                                <td width="15%" align="right">{{ agentSumTotal.toFixed(2) }}&nbsp;</td>
                                <td width="15%" align="right">{{ advanceMoneyTotal.toFixed(2) }}&nbsp;</td>
                            </tr>
                        </tfoot> -->
                    </table>
                </div>
                <div id="foot">
                    <div style="width:200mm;padding-top: 5px;margin: 0 auto;">
                        <div style="display: inline-block;width:50%;">打印人：{{ employeeName }}</div>
                        <div style="display: inline-block;width:50%;text-align: right;">打印日期：{{ printDate }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" v-print="'#printListContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: false,
            type: Boolean
        },
        isDefaultSet: {
            default: false,
            type: Boolean
        },
        isPreview: {
            default: false,
            type: Boolean
        },
        sParams: {
            type: Object
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            rSumPayableTotal: 0,
            agentSumTotal: 0,
            advanceMoneyTotal: 0,
            employeeName: userMsg.EmployeeName,
            printDate: '',
            searchParams: {},
            dataList: [],
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '应收账列表'
            } //标题配置
        };
    },
    watch: {},
    created() {},
    mounted() {
        if (this.isInit) {
            this.getConfigByCodes().then(() => {
                this.init(false);
            });
        }
    },
    methods: {
        init(isPrint) {
            let that = this;
            that.loading = true;
            that.rSumPayableTotal = 0;
            that.agentSumTotal = 0;
            that.advanceMoneyTotal = 0;
            that.dataList = [];
            if (that.sParams) {
                that.sParams.Page = 1;
                that.searchParams = { ...that.sParams };
            } else {
                that.searchParams = {};
            }
            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
            that.printDate = `${year1}-${month1}-${day1}`;
            that.getCusItemizedSummary(isPrint);
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyszgllbbt'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyszgllbbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '应收账列表';
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getCusItemizedSummary(isPrint) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_H/GetCusItemizedSummary',
                    data: that.searchParams,
                    hideLoading: that.isInit
                })
                .then(res => {
                    let data = res.data;
                    if (!data.DataList || data.DataList.length == 0) {
                        if (that.searchData.Page == 1) that.tableData = [];
                        return;
                    } else {
                        let list = [...that.dataList, ...data.DataList];
                        that.dataList = list;
                        if (that.dataList.length < res.count) {
                            that.searchParams.Page++;
                            this.getCusItemizedSummary();
                        } else {
                            that.dataList.forEach(e => {
                                that.rSumPayableTotal += e.RSumPayable;
                                that.agentSumTotal += e.AgentSum;
                                that.advanceMoneyTotal += e.AdvanceMoney;
                            });
                            if (that.isInit) that.loading = false;
                            else {
                                this.$nextTick(() => {
                                    setTimeout(() => {
                                        that.lodopPrint();
                                    }, 100);
                                });
                            }
                        }
                    }
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 20px 0;
                    }

                    .print-title-view .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                   
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                    /* 为了兼容火狐不换行 */
                    td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
                    table{
                        width: 763px;
                        margin: 0 auto;
                        border-top: solid 1px black;                    
                    }               
                `;
                LODOP.PRINT_INIT('打印应收账列表');
                // 设定打印项在纸张范围内的水平方向的位置锁定方式。
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let printContentHeight = document.getElementById('printListContent').clientHeight;
                let topHeight = document.querySelector('#printListContent #top').clientHeight;
                let tableHeight = document.querySelector('#printListContent #table').clientHeight;
                let footHeight = document.querySelector('#printListContent #foot').clientHeight;
                let printTableH = 1080 - topHeight;
                let pageFootTop = printTableH;
                if (printContentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    pageFootTop = printContentHeight;
                    // printTableH = 950;
                }
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printListContent #top').innerHTML);
                // LODOP.ADD_PRINT_TABLE(topHeight, 0, '100%', printTableH, `<style>${tableStyle}</style>` + document.querySelector('#printListContent #table').innerHTML);
                LODOP.ADD_PRINT_TABLE(
                    topHeight,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printListContent #table').innerHTML
                );
                LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 2); //高度包含页头
                // //次页开始的上边距偏移量
                // LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight + 3);
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', document.querySelector('#printListContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);

                LODOP.ADD_PRINT_HTM(10, 690, 300, 10, "<font><span tdata='pageNO' format='#'>第#页</span> / <span tdata='pageCount' format='#'>共#页</span></font>");
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 1);
                // LODOP.ADD_PRINT_HTM(pageFootTop + 20, 15, 300, 10, '<font>应收帐列表</font>');
                // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                // LODOP.PRINT_DESIGN();

                if (!this.isInit) this.dataList = [];
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
}

.print-title-view .print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    // justify-content: right;
    justify-content: space-between;
    margin-top: 20px;
}
.btn-ctn-left {
    display: flex;
}
.re-submit {
    text-align: right;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
</style>
